import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { AvailableInternship } from '../models/availableInternship.models';

export interface CreateAvailableInternshipAvailability {
  canCreate: boolean;
  reason: string;
  reasonParams?: Record<string, string>;
}

@Injectable({
  providedIn: 'root'
})
export class InternshipsService {

  constructor(private http: HttpClient) { }


  getAllAvailableInternships(): Observable<AvailableInternship[]> {
    const token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${token}`
    };

    console.log("dev get tirocini disponibili",environment.apiUrl);

    return this.http.get<AvailableInternship[]>(environment.apiUrl + `/api/available-internships/me`,{headers});
  }

  getAvailableInternshipsById(id:number): Observable<AvailableInternship[]> {
    const token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.get<AvailableInternship[]>(environment.apiUrl + `/api/available-internships/${id}`,{headers});
  }
    
  updateVisibility(id: number, visibility: boolean): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.put(
      environment.apiUrl + `/api/available-internships/${id}/visibility`,
      { visibility },
      { headers }
    );
  }

  updateAvailableInternship(id: number, dto: any): Observable<AvailableInternship> {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.put<AvailableInternship>(
      environment.apiUrl + `/api/available-internships/${id}`,
      dto,
      { headers }
    );
  }

  deleteAvailableInternship(id: number): Observable<string> {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.delete(
      environment.apiUrl + `/api/available-internships/${id}`,
      { headers, responseType: 'text' } 
    );
  }

  canCreateAvailableInternship(): Observable<CreateAvailableInternshipAvailability> {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
    return this.http.get<CreateAvailableInternshipAvailability>(`${environment.apiUrl}/api/available-internships/can-create-internship`,{headers});
  }
  

  
}
